import { useSelector } from 'react-redux';
import { Button } from '@vinted/web-ui';
import useTracking from 'hooks/useTracking';
import useTranslate from 'hooks/useTranslate';
import { clickEvent } from 'libs/common/event-tracker/events';
import { toUrlQuery } from 'libs/utils/url';
import { ITEM_UPLOAD_URL, SIGNUP_URL } from 'constants/routes';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { getUserId } from 'state/session/selectors';
import { jsx as _jsx } from "react/jsx-runtime";

const HeaderUploadItem = () => {
  const userId = useSelector(getUserId);
  const translate = useTranslate();
  const {
    track
  } = useTracking();

  function handleAnchorClick() {
    track(clickEvent({
      target: ClickableElement.UploadItem
    }));
  }

  return /*#__PURE__*/_jsx(Button, {
    text: translate('header.actions.upload_item'),
    styling: Button.Styling.Filled,
    size: Button.Size.Small,
    url: userId ? ITEM_UPLOAD_URL : "".concat(SIGNUP_URL, "?").concat(toUrlQuery({
      ref_url: ITEM_UPLOAD_URL
    })),
    rel: "nofollow",
    onClick: handleAnchorClick
  });
};

export default HeaderUploadItem;